import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const IDLE_MINUTES = 30;

// Auto-logout after IDLE_MINUTES of no user activity.
export default function IdleTimeout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!user || user === false) return;
    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(async () => {
        toast("Signed you out due to inactivity.", { duration: 6000 });
        await logout();
        nav("/login");
      }, IDLE_MINUTES * 60 * 1000);
    };
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((ev) => window.addEventListener(ev, reset, { passive: true }));
    reset();
    return () => {
      events.forEach((ev) => window.removeEventListener(ev, reset));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [user, logout, nav]);

  return null;
}
